import Vue from 'vue'

const state = {
	status: false,
	profile: {}
}

const getters = {
	getProfile: state => state.profile,

	getUserId: state => console.log('userid'),

	isProfileLoaded: state => !!state.profile.name,

	status: status => state.status
}

const actions = {
	USER_REQUEST: ({ commit }) => {
		commit('USER_REQUEST')
		Vue.axios({ url: 'user-details', method: 'GET' })
			.then(resp => {
				localStorage.user = JSON.stringify(resp.data.data)
				commit('USER_SUCCESS', resp.data.data)
			})
			.catch(resp => {
				if (resp.message == 'Network Error' && localStorage.user) {
					commit('USER_SUCCESS', JSON.parse(localStorage.user))
				} else {
					commit('USER_ERROR')
					// if resp is unauthorized, logout, to
					dispatch('AUTH_LOGOUT')
				}
			})
	}
}

const mutations = {
	USER_REQUEST: state => {
		state.status = 'loading'
	},

	USER_SUCCESS: (state, resp) => {
		state.profile = resp.user
		state.status = true
	},

	USER_ERROR: state => {
		state.status = false
	},

	AUTH_LOGOUT: state => {
		state.profile = {}
		delete localStorage.user
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
